import { Horizontal, MaterialIcon, Texto } from '@gravitate-js/excalibrr'
import React, { useEffect } from 'react'

interface OrderNavigationHeaderProps {
  currentIndex: number
  totalOrders: number
  onPrevious: () => void
  onNext: () => void
}

export function OrderNavigationHeader({ currentIndex, totalOrders, onPrevious, onNext }: OrderNavigationHeaderProps) {
  const isFirstOrder = currentIndex <= 0
  const isLastOrder = currentIndex >= totalOrders - 1

  // Add keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Ignore if user is typing in an input
      if (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement) {
        return
      }

      switch (e.key) {
        case 'ArrowLeft':
          if (!isFirstOrder) {
            onPrevious()
          }
          break
        case 'ArrowRight':
          if (!isLastOrder) {
            onNext()
          }
          break
        default:
          break
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [isFirstOrder, isLastOrder, onPrevious, onNext])
  if (currentIndex === -1) return null
  return (
    <Horizontal verticalCenter className='py-2' style={{ width: '100%', justifyContent: 'flex-end' }} gap={8}>
      <Texto category='h5' weight='bold'>
        Order Navigation
      </Texto>
      <Texto category='p2' style={{ textAlign: 'center' }}>
        {currentIndex + 1} of {totalOrders}
      </Texto>
      <MaterialIcon
        icon='chevron_left'
        style={{
          fontSize: 24,
          cursor: isFirstOrder ? 'not-allowed' : 'pointer',
          opacity: isFirstOrder ? 0.5 : 1,
        }}
        onClick={onPrevious}
      />
      <MaterialIcon
        icon='chevron_right'
        style={{
          fontSize: 24,
          cursor: isLastOrder ? 'not-allowed' : 'pointer',
          opacity: isLastOrder ? 0.5 : 1,
        }}
        onClick={onNext}
      />
    </Horizontal>
  )
}
